import { render } from "./LoginView.vue?vue&type=template&id=f05c0c28&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=f05c0c28&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05c0c28"]])

export default __exports__